/**IMPORTANT LIBRARY IMPORT */
import React from "react";

/**COMPONENT IMPORT */
import PageHero from "../Components/PageHero";


const Blog=()=>{


    return(
        <>
         {/**HERO SECTION */}
        <PageHero heading={"Blog"}/>
        </>
    )
}

export default Blog;